import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { PixKeyType } from '../../models/key-type.enum';
import { PixKey } from '../../models/key.model';
import { PixMenu } from '../../models/pix-menu.enum';
import { PixWithdrawChangeFaqComponent } from '../faq/faq.component';

@Component({
	selector: 'app-pix-withdraw-change-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixWithdrawChangeMenuComponent {
	public mainKey: PixKey;

	constructor(private router: Router, 	public dialog: MatDialog) { }

	get pixMenu(): typeof PixMenu {
		return PixMenu;
	}

	public get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	redirectToOnboarding(): void{
			this.router.navigate(['pix/onboarding', {returnToWithdrawChangeMenu: true}]);
	}

	openFaqModal(): void{
		this.dialog.open(PixWithdrawChangeFaqComponent, {
			width: '400px',
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/menu/menu.component.ts